import React from "react";

// Cierre del resultado neutro: invita a revisar la ficha del modelo. El enlace
// lo entrega /versions/ (`spec_sheet_url`), que sale del documento opcional
// cargado en el modelo; sin ficha cargada la tarjeta no se renderiza.
const SpecSheetCard = ({ url }) => {
    if (!url) return null;

    return (
        <div className="savings-calculator__spec-card">
            <div className="savings-calculator__spec-card-head">
                <svg
                    className="savings-calculator__spec-card-icon"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                    focusable="false"
                >
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <path d="M14 2v6h6M8 13h8M8 17h5" />
                </svg>
                <p className="savings-calculator__spec-card-text">
                    Revisa más en detalle las especificaciones del modelo y sus versiones.
                </p>
            </div>
            <a className="savings-calculator__spec-card-link" href={url} target="_blank" rel="noopener noreferrer">
                Ver ficha técnica <span aria-hidden="true">→</span>
            </a>
        </div>
    );
};

export default SpecSheetCard;
